import React from 'react';
import { useCookie } from '../../hooks/useCookie';
import { useFavorites, useIsFavorite } from '../../hooks/useFavorites';
import FavoriteButton from './FavoriteButton';

const FavoriteButtonHooked = ({ titleId }) => {
    const [isFavorite, setIsFavorite] = useIsFavorite(titleId);
    // eslint-disable-next-line no-unused-vars
    const [favorites, addFavorite, removeFavorite] = useFavorites();
    const [storedValue, setValue] = useCookie(`onboarding-favorites`, false);

    return (
        <FavoriteButton
            titleId={titleId}
            isFavorite={isFavorite}
            addFavorite={addFavorite}
            removeFavorite={removeFavorite}
            setIsFavorite={setIsFavorite}
            setValue={setValue}
            storedValue={storedValue}
        />
    );
};

export default FavoriteButtonHooked;
